exports.components = {
  "component---src-templates-default-not-found-jsx": () => import("./../../../src/templates/default/not-found.jsx" /* webpackChunkName: "component---src-templates-default-not-found-jsx" */),
  "component---src-templates-default-page-jsx": () => import("./../../../src/templates/default/page.jsx" /* webpackChunkName: "component---src-templates-default-page-jsx" */)
}

